import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/poukazy" as const,
	[Locale.en]: "/vouchers" as const,
} satisfies LocalizedString;

export function getPurchasableCouponsListingPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
